import * as Sentry from '@sentry/browser';

const { REACT_APP_CURRENT_RUNNING_ENVIRONMENT } = process.env;

if (
  !['dev', 'uat1', 'uat2', 'uat3', 'uat4', 'uat5'].includes(REACT_APP_CURRENT_RUNNING_ENVIRONMENT)
) {
  Sentry.init({
    dsn: 'https://16dabad985dd45a78593b9931ca3efdf@o24149.ingest.sentry.io/5210427',
    environment: REACT_APP_CURRENT_RUNNING_ENVIRONMENT,
  });
}
